import createAction from '../../../../util/createAction';

export const CHOOSE_PARENT = 'addon/parent/CHOOSE';
export const chooseParent = createAction(CHOOSE_PARENT);
